import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const reportService = {
  getSalesSummary, getTopDebtors, getMonthlyTrend, getWeeklyTrend,
  getSalesByAgent, getSalesByProduct, getSalesByClientGroup,
  getStockBuffer, getStockMovement, getMarketStock, getAgentStock, getAgentStockDetail,
  getRecentSalesDocs,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const p = {}
  if (filter?.dateFrom) p.date_from = filter.dateFrom
  if (filter?.dateTo) p.date_to = filter.dateTo
  if (filter?.agentCode) p.agent_code = filter.agentCode
  if (filter?.limit) p.limit = filter.limit
  return p
}

export function getSalesSummary(filter) { return apiHelper(API_URL).get('/reports/sales-summary', { params: buildParams(filter) }) }
export function getTopDebtors(filter) { return apiHelper(API_URL).get('/reports/top-debtors', { params: buildParams(filter) }) }
export function getMonthlyTrend(filter) { return apiHelper(API_URL).get('/reports/monthly-trend', { params: buildParams(filter) }) }
export function getWeeklyTrend(filter) { return apiHelper(API_URL).get('/reports/weekly-trend', { params: buildParams(filter) }) }
export function getSalesByAgent(filter) { return apiHelper(API_URL).get('/reports/sales-by-agent', { params: buildParams(filter) }) }
export function getSalesByProduct(filter) { return apiHelper(API_URL).get('/reports/sales-by-product', { params: buildParams(filter) }) }
export function getSalesByClientGroup(filter) {
  const params = buildParams(filter)
  if (filter?.groupBy) params.group_by = filter.groupBy
  return apiHelper(API_URL).get('/reports/sales-by-client-group', { params })
}
export function getStockBuffer(filter) { return apiHelper(API_URL).get('/reports/stock-buffer', { params: buildParams(filter) }) }
export function getStockMovement(filter) { return apiHelper(API_URL).get('/reports/stock-movement', { params: buildParams(filter) }) }
export function getMarketStock(filter) { return apiHelper(API_URL).get('/reports/market-stock', { params: buildParams(filter) }) }
export function getAgentStock(filter) { return apiHelper(API_URL).get('/reports/agent-stock', { params: buildParams(filter) }) }
export function getAgentStockDetail(locationCode) { return apiHelper(API_URL).get(`/reports/agent-stock/${encodeURIComponent(locationCode)}`) }
export function getRecentSalesDocs(filter) { return apiHelper(API_URL).get('/reports/recent-sales-docs', { params: buildParams(filter) }) }
